module.exports = __webpack_public_path__ + "static/media/fire6.1f86580f.svg";